// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__whVFF","buttons":"Banner_buttons__CCCeV","content":"Banner_content__Z13lu","image":"Banner_image__+VqOu","skeleton":"Banner_skeleton__ry1+c"};